import routerOptions0 from "/usr/src/app/content/n3-redirections-service-8b637909-b96b-4092-8440-db1a6e672845/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}